// import { Provider } from 'react-redux';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
// import Auth from './layout/Auth';
import Main from './layout/Main';
import AdminLayout from './layout/Admin';
import Auth from './layout/Auth';
import routes from './routes';
// import store from './store';
function App() {
	return (
		<>
			<BrowserRouter>
				<Switch>
					{routes.map(route => {
						switch (route.layout) {
							case 'main':
								return (
									<Route exact path={route.path}>
										<Main>
											<route.component />
										</Main>
									</Route>
								);
							case 'auth':
								return (
									<Route exact path={route.path}>
										<Auth>
											<route.component />
										</Auth>
									</Route>
								);
							case 'admin':
								return (
									<Route exact path={route.path}>
										<AdminLayout>
											<route.component />
										</AdminLayout>
									</Route>
								);
							default:
								return <Redirect to='/' />;
						}
					})}
					{/* <Redirect to='/' /> */}
				</Switch>
			</BrowserRouter>
		</>
	);
}

export default App;
